export default __webpack_public_path__ + "81179a0febb3f23b51edbe69a1f5a480.png";